import React, { Component } from 'react';

class Index extends Component {
  render() {
    return null;
  }
}

export default Index;
